/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import $ from 'jquery';
import React from 'react';

import i18n from '../../../../i18n/AdHocBundle.properties';
import Dialog from 'js-sdk/src/components/dialog/ReactDialog';
import TabComponent from './TabComponent';
import BodyComponent from './BodyComponent';
import VisualizationTypesController from '../../visualizationTypes/VisualizationTypesController';

const ALL_ITEMS_TAB_VALUE = 'all';

export default class VisualChooserComponent extends React.Component {

    constructor(props) {
        super(props);

        this.typeManager = new VisualizationTypesController();

        this.$el = null;
        this.state = {
            selectedTypeOnOpen: this.props.selectedType || ''
        };
        this.appliedState = null;
    }

    shouldComponentUpdate(nextProps) {
        if (!this.props.isVisible && nextProps.isVisible) {
            this.setState((state, props) => {
                return {
                    selectedTypeOnOpen: props.selectedType
                }
            });
        }
        return true;
    }

    componentDidMount() {
        this.$el[0].style.removeProperty('z-index');
    }

    getComponentState () {
        return {
            tabComponent: this._tabComponent.getState(),
            bodyComponent: this._bodyComponent.getState(),
            width: this.$el.width(),
            height: this.$el.height(),
            position: this.$el.offset()
        }
    }

    applyComponentState (state) {
        this._tabComponent.setState(state.tabComponent);
        this._bodyComponent.applyState(state.bodyComponent);
        this.appliedState = state;
    }

    render() {

        this.typeManager.setTypesToExclude(this.props.typesToExclude || []);

        const inDesignMode = this.props.inDesignMode || false;
        const isVisible = this.props.isVisible || false;
        const isCollapsed = this.props.isCollapsed || false;
        const selectedGroup = this.props.selectedGroup || ALL_ITEMS_TAB_VALUE;
        const selectedType = this.props.selectedType || '';
        const disabledTypes = this.props.disabledTypes || [];

        const dialogButtons = [{
            type: 'primary',
            title: inDesignMode ? i18n['visualization.chooser.applyAndClose.button'] : i18n['visualization.chooser.ok.button'],
            onClick: this._onPrimaryButtonClick.bind(this)
        }, {
            type: 'secondary',
            title: i18n['visualization.chooser.cancel.button'],
            onClick: this._onCancelButtonClick.bind(this)
        }]

        let dialogWidth = 700;
        let dialogHeight = 475;
        let initialPosition = 'center';
        if (this.appliedState) {
            if (this.appliedState.width) {
                dialogWidth = this.appliedState.width;
            }
            if (this.appliedState.height) {
                dialogHeight = this.appliedState.height;
            }
            if (this.appliedState.position) {
                initialPosition = {
                    top: this.appliedState.position.top,
                    left: this.appliedState.position.left
                };
            }
        }

        return (
            <Dialog
                passRootElement = { this._passRootElement.bind(this) }
                title = { i18n['visualization.chooser.title'] }
                isVisible = { isVisible }
                headerCrossCloser = { false }
                dialogClass = { 'jr-mVisualChooserDialog' }
                draggable = { true }
                resizable = { true }
                initialPosition = { initialPosition }
                initialWidth = { dialogWidth }
                initialHeight = { dialogHeight }
                width = { dialogWidth }
                height = { dialogHeight }
                minWidth = { 504 }
                minHeight = { 475 }
                maxWidth = { 1250 }
                maxHeight = { 800 }
                buttons = { dialogButtons }
            >
                <div
                    className="jr jr-mVisualchooser"
                >
                    <TabComponent
                        ref = { this._saveTabComponent.bind(this) }
                        typeManager = { this.typeManager }
                        initialCollapsedState = { isCollapsed }
                        selectedGroup = { selectedGroup }
                        onGroupChangeCallback = { this._onGroupChangeCallback.bind(this) }
                        onTabCollapseCallback = { this._onTabCollapseCallback.bind(this) }
                    />
                    <BodyComponent
                        ref = { this._saveBodyComponent.bind(this) }
                        selectedGroup = { selectedGroup }
                        typeManager = { this.typeManager }
                        inDesignMode = { inDesignMode }
                        selectedType = { selectedType }
                        disabledTypes = { disabledTypes }
                        onVisualizationChange = { this._onVisualizationChange.bind(this) }
                    />
                </div>
            </Dialog>
        );
    }

    _passRootElement (el) {
        this.$el = $(el);
    }

    _saveTabComponent (tabComponent) {
        this._tabComponent = tabComponent;
    }

    _saveBodyComponent (bodyComponent) {
        this._bodyComponent = bodyComponent;
    }

    _onVisualizationChange (newType) {
        if (this.props.onVisualizationChange) {
            this.props.onVisualizationChange(newType);
        }
    }

    _onPrimaryButtonClick () {
        if (this.props.onPrimaryButtonClick) {
            this.props.onPrimaryButtonClick();
        }
    }

    _onCancelButtonClick () {
        if (this.state.selectedTypeOnOpen) {
            if (this.state.selectedTypeOnOpen !== this.props.selectedType) {
                let type = this.typeManager.getTypeByName(this.state.selectedTypeOnOpen);
                if (this.props.onVisualizationChange) {
                    this.props.onVisualizationChange({
                        type: type.name,
                        legacyAdhocType: type.legacyAdhoc
                    });
                }
            }
        }
        if (this.props.onCancelButtonClick) {
            this.props.onCancelButtonClick();
        }
    }

    _onGroupChangeCallback (newGroupName) {
        if (this.props.onSelectedGroupChange) {
            this.props.onSelectedGroupChange(newGroupName);
        }
    }

    _onTabCollapseCallback (isCollapsed, tabSize) {

        const position = this.$el.offset();
        let width = this.$el.width();

        if (isCollapsed) {
            // the tab was expanded and now it's collapsed, so we need to lessen the dialog width
            width -= tabSize;
            // and move the dialog to the right
            position.left = position.left + tabSize;
        } else {
            // the tab was collapsed and now it's expanded, so we need to lessen the dialog width
            width += tabSize
            // and move the dialog to the left
            position.left = position.left - tabSize;
        }

        if (position.left < 0) {
            position.left = 0;
        }

        this.$el.offset(position);
        this.$el.width(width);
    }
}
